/** Route element for `/haven`: full-screen Haven is drawn by the chat in `Layout`, so the page itself is empty. */
export const HavenRoute = () => null
